import { makeStyles } from '@material-ui/core/styles';
import { DIMENSIONS } from '../../styles/constants';

export const useStyles = makeStyles(theme => ({
	root: {
		flexGrow: 1
	},
	appbar: {
		backgroundColor: theme.palette.common.white,
		zIndex: 101,
		marginTop: DIMENSIONS.NAVBAR_HEIGHT_XS + 25
	},
	toolbar: {
		minHeight: DIMENSIONS.NAVBAR_HEIGHT_XS,
		[`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
			minHeight: DIMENSIONS.NAVBAR_HEIGHT_XS
		},
		[theme.breakpoints.up('sm')]: {
			minHeight: DIMENSIONS.NAVBAR_HEIGHT
		},
		color: theme.palette.common.black
	},
	leftContainer: {
		flexGrow: 1,
		display: 'flex',
		alignItems: 'center'
	},
	actionsContainer: {
		width: 'auto'
	},
	focusableIconButton: {
		'&:focus': {
			boxShadow: '0 0 0'
		}
	},
	title: {
		fontWeight: 600,
		color: theme.palette.text.primary,
		fontSize: theme.typography.body2.fontSize
	},
	mainTitle: {
		fontWeight: 600,
		color: theme.palette.text.primary
	}
}));
